module.exports = __webpack_public_path__ + "img/1to3.51b3cb78.jpg";